import { CREATE_DMX_UNIVERSE, CREATE_DMX_UNIVERSE_SUCCESSFUL, CREATE_DMX_UNIVERSE_FAILED } from './actionTypes';

const initialState = {
  createDmxUniverseError: null,
  messageDmxUniverse: null,
  loadingCreateDmxUniverse: false,
};

const createUniverse = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DMX_UNIVERSE:
      state = { ...state, loadingCreateDmxUniverse: true, createDmxUniverseError: null };
      break;
    case CREATE_DMX_UNIVERSE_SUCCESSFUL:
      state = { ...state, loadingCreateDmxUniverse: false, messageDmxUniverse: action.payload, createDmxUniverseError: null };
      break;
    case CREATE_DMX_UNIVERSE_FAILED:
      state = { ...state, messageDmxUniverse: null, loadingCreateDmxUniverse: false, createDmxUniverseError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createUniverse;
